module.exports = __webpack_public_path__ + "assets/img/certification2.22837091.svg";